import { render } from "./CreateL2NetworkForm.vue?vue&type=template&id=2f450693&scoped=true"
import script from "./CreateL2NetworkForm.vue?vue&type=script&lang=js"
export * from "./CreateL2NetworkForm.vue?vue&type=script&lang=js"

import "./CreateL2NetworkForm.vue?vue&type=style&index=0&id=2f450693&lang=less&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f450693"]])

export default __exports__